import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'
import InstitutionInactive from '../../../../Institutions/components/institutionInactive/institutionInactive.vue'

export default {
  props: {
    equipmentSelected: Array,
  },

  data: () => ({
    loading: false,
    error: false,
    menuFirstDate: false,
    alterDialog: false,
    infoDialog: false,
    firstValid: true,
    repetitionDisabled: true,
    institutionInactive: false,
    errorMessage: '',
    firstDate: null,
    scheduleFirstDate: null,
    scheduledDates: [],
    institutionId: null,
    period: null,
    typesSelected: [],
    repetition: null,
    maxRepetition: 0,
    repetitionPlaceholder: '',
    addMonth: null,
    responsibility: null,
    internalTeam: null,
    types: [
      'Preventiva',
      'Calibração',
      'Segurança elétrica',
      'Treinamento',
      'Validação/Qualificação',
    ],
    periods: [
      'Sem repetição',
      'Mensal',
      'Bimestral',
      'Trimestral',
      'Quadrimestral',
      'Semestral',
      'Anual',
    ],
    responsibilities: ['Interna', 'Externa'],
    firstDateRules: [(v) => !!v || 'Data agendamento requerida'],
    responsibilityRules: [(v) => !!v || 'Responsabilidade requerida'],
    apiService: new ApiService(),
  }),

  async created() {
    this.period = this.periods[0]
    const institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = institution.id
    this.institutionInactive = institution.status == 1
  },

  components: {
    InstitutionInactive,
  },

  methods: {
    close() {
      this.$emit('clearSelection')
      this.$emit('close')
    },

    closeDialog() {
      if (this.type || this.firstDate) {
        this.alterDialog = true
      } else {
        this.close()
      }
    },

    typesQuantityRules() {
      if (this.typesSelected) return this.typesSelected.length <= 3
    },

    saveForm() {
      if (this.$refs.firstForm.validate()) {
        this.infoDialog = true
      }
    },

    async submit() {
      this.loading = true

      const dates = this.scheduledDates.map((date) => {
        return this.parseDate(date)
      })

      const model = {
        ServiceOrderTypes: this.typesSelected,
        Equipment: this.equipmentSelected,
        ScheduleDates: dates,
        InstitutionId: this.institutionId,
        internalTeam: this.internalTeam,
        Responsibility: this.responsibilities.indexOf(this.responsibility),
      }

      await this.apiService
        .post('serviceOrder/createServiceOrderSchedule', model)
        .then((response) => {
          this.$emit('show', 'Agendamendo criado com sucesso')
          this.close()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
    },

    periodSelected() {
      const index = this.periods.indexOf(this.period)

      this.repetitionDisabled = index == 0
      this.repetition = null

      switch (index) {
        case 1:
          this.maxRepetition = 23
          this.repetitionPlaceholder = 'Valor máximo 23'
          this.addMonth = 1
          break
        case 2:
          this.maxRepetition = 11
          this.repetitionPlaceholder = 'Valor máximo 11'
          this.addMonth = 2
          break
        case 3:
          this.maxRepetition = 7
          this.repetitionPlaceholder = 'Valor máximo 7'
          this.addMonth = 3
          break
        case 4:
          this.maxRepetition = 5
          this.repetitionPlaceholder = 'Valor máximo 5'
          this.addMonth = 4
          break
        case 5:
          this.maxRepetition = 3
          this.repetitionPlaceholder = 'Valor máximo 3'
          this.addMonth = 6
          break
        case 6:
          this.maxRepetition = 1
          this.repetitionPlaceholder = 'Valor máximo 1'
          this.addMonth = 12
          break
        default:
          this.maxRepetition = 0
          this.repetitionPlaceholder = ''
          this.scheduledDates = [this.firstDate]
          break
      }
    },

    calculateRepetitions() {
      if (this.repetition > this.maxRepetition) {
        this.repetition = this.maxRepetition
      }
      if (this.repetition > 0 && this.firstDate) {
        this.scheduledDates = [this.firstDate]
        for (let i = 1; i <= this.repetition; i++) {
          const newDate = Utils.addMonths(this.firstDate, this.addMonth * i)
          this.scheduledDates.push(this.formatDate(newDate))
        }
      }
    },

    removeServiceOrderType(item) {
      this.typesSelected.splice(this.typesSelected.indexOf(item), 1)
      this.typesSelected = [...this.typesSelected]
    },

    formatDate(date) {
      return Utils.moment(date)
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    save(date) {
      this.scheduledDates = []
      this.firstDate = this.formatInputDate(this.scheduleFirstDate)
      this.scheduledDates.push(this.firstDate)
      this.$refs.menuFirstDate.save(date)
    },
  },

  watch: {},
}
